<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">法人編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'corporation-id-detail' : 'corporation-detail', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporation.uid }}</td>
              </tr>
              <PasswordField vid="password" v-model="password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="法人情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>法人情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import PasswordField from '@/components/forms/PasswordField.vue';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('corporation/fetchCorporation', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    ValidationObserver,
    PasswordField,
    PopUpHolder,
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  computed: {
    currentCorporation() {
      return this.corporation.corporation;
    },
    ...mapState(['corporation']),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentCorporation.id,
        password: this.password,
      };
      this.changeCorporationPassword(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        // This path is for TIE Role
        this.$logger.debug('Password Changed for ID: ' + this.id);
        this.$router.push({ name: 'corporation-id-detail', params: { id: this.id } });
      } else {
        // This path is for Corporation Role
        this.$logger.debug('Password Changed');
        this.$router.push({ name: 'corporation-detail' });
      }
    },
    ...mapActions('corporation', ['changeCorporationPassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.line-break {
  width: 100%;
}
</style>
